import React, {Fragment} from "react";
import anime from "animejs";

import "./styles.scss";

class Congrats extends React.Component {

    componentDidMount() {
        var basicTimeline = anime.timeline({loop: false});
        var textWrapper = document.querySelector('.ml6 .letters');
        textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
        
        basicTimeline
            .add({
                targets: '.ml5 .line',
                opacity: [0.5, 1],
                scaleX: [0, 1],
                easing: "easeInOutExpo",
                duration: 700
            })
            .add({
                targets: '.ml5 .line',
                duration: 600,
                easing: "easeOutExpo",
                translateY: function (e, i, l) {
                    var offset = -0.625 + 0.625 * 2 * i;
                    return offset + "em";
                }
            })
            .add({
                targets: '.ml5 .congratulations',
                opacity: [0, 1],
                translateX: ["0.5em", 0],
                easing: "easeOutExpo",
                duration: 600,
                offset: '-=300'
            })
            .add({
                targets: '.ml5 .finished',
                opacity: [0, 1],
                translateX: ["0.5em", 0],
                easing: "easeOutExpo",
                duration: 600,
                offset: '-=300'
            })
            .add({
                targets: '.ml5 .exclamation',
                opacity: [0, 1],
                scaleY: [0.5, 1],
                easing: "easeOutExpo",
                duration: 600,
                offset: '-=600'
            })
            .add({
                targets: '.ml6 .letter',
                translateY: ["1.1em", 0],
                translateZ: 0,
                duration: 750,
                delay: function (el, i) {
                    return 50 * i;
                }
            })
            .add({
                targets: '.ml6',
                opacity: 1,
                duration: 1000,
                easing: "easeOutExpo",
                delay: 1000
            })
            .add({
                targets: '.ml5',
                opacity: 1,
                duration: 1000,
                easing: "easeOutExpo",
                delay: 1000
            });
    }

    componentDidUpdate() {


    }

    render() {
        return (
            <Fragment>
                <h1 className="ml5">
                <span className="text-wrapper">
                <span className="line line1"> </span>
                <span className="letters congratulations">Great</span>
                <span className="letters finished">Job</span>
                  <span className="letters exclamation">!</span>
                <span className="line line2"> </span>
              </span>
                </h1>
                <p className="ml6">
                    <span className="text-wrapper">
                        <span className="letters">Please wait while we tailor your experience</span>
                  </span>
                </p>
            </Fragment>
        );
    }
}


export default Congrats